import GoogleMapDataViewer from "./GoogleMapDataViewer.js";
import RendererSetup from "./renderers/PluginSetup.js";
import Actions from "./actions/PluginSetup.js";
import GoogleMapViewerModel from "./models/GoogleMapViewerModel.js";
import GoogleMapViewerEditor from "./models/GoogleMapViewerEditor.js";
export default {
  install(molten) {
    molten.addPlugin('Model', {
      type: GoogleMapViewerModel.TYPE,
      model: GoogleMapViewerModel
    });
    molten.addPlugin('ModelEditor', {
      type: GoogleMapViewerModel.TYPE,
      editor: GoogleMapViewerEditor
    });
    molten.addPlugin('DataViewer', GoogleMapDataViewer);
    RendererSetup.install(molten);
    Actions.install(molten);
  }
};